<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <b-table
      ref="quoteTable"
      :items="list"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative table-bordered"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>
      <template #thead-top="">
        <b-tr>
          <b-th
            colspan="2"
            style="background: none"
          />
          <b-th
            v-if="!isTargeted()"
            colspan="2"
            class="text-center"
            style="background: none"
          >
            {{ $t('Scientific potential of the institute') }}
          </b-th>
          <b-th
            v-if="!isTargeted()"
            colspan="3"
            class="text-center"
            style="background: none"
          >
            {{ $t('Number of students at the institute') }}
          </b-th>
          <b-th
            :colspan="dcTypes.length"
            class="text-center"
            style="background: none"
          >
            {{ $t('The need for specialization for {year}', { year: letter.period.admission_year}) }}
          </b-th>
          <b-th style="background: none" />
        </b-tr>
      </template>
      <template
        v-for="dcType in dcTypes"
        v-slot:[`head(${dcType.id})`]=""
      >
        {{ $langName(getDcType(dcType.id).name) }}
      </template>

      <template
        v-for="dcType in dcTypes"
        v-slot:[`cell(${dcType.id})`]="data"
      >
        {{ data.item.dc_type[dcType.id] }}
      </template>

      <template #cell(direction)="data">
        {{ data.item.direction.name[$i18n.locale] }} ({{ data.item.direction.code }})
      </template>
      <template #head(actions)="data">
        {{ $t(data.label) }}
      </template>
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label="Text Centered"
          />
        </div>
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <feather-icon
            v-if="canUpdate(data.item)"
            v-b-toggle.sidebar-create-quote
            icon="EditIcon"
            class="mr-1 cursor-pointer"
            size="16"
            @click="update(data.item)"
          />
          <feather-icon
            v-if="canDelete(data.item)"
            icon="TrashIcon"
            class="mr-1 cursor-pointer"
            size="16"
            @click="remove(data.item)"
          />
        </div>
      </template>
    </b-table>
    <create
      v-if="letter.id"
      @refetchData="refetchDataMethod"
    />
  </b-card>

</template>

<script>
import {
  BCard, BSpinner, BTable, VBToggle, BTr, BTh,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import quoteModule from '@/store/quote/index'
import Create from './Create.vue'
import permission from './permission'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BTable,
    BSpinner,
    Create,
    BTr,
    BTh,
  },
  computed: {
    letter() {
      return this.$store.state.letter.letter
    },
    dcTypes() {
      return this.$store.getters[this.isTargeted() ? 'staticModule/getTargetedDcTypes' : 'staticModule/getSimpleDcTypes']
    },
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`, this.$route.params.id)
    this.$store.dispatch('staticModule/dcType')
    if (this.isTargeted()) {
      this.tableColumns = [
        { key: 'index', label: '#' },
        { key: 'direction', label: 'Direction', sortable: true },
      ]
    }
    const { dcTypes } = this
    dcTypes.forEach(dcType => {
      this.tableColumns.push({
        key: `${dcType.id}`,
      })
    })
    this.tableColumns.push({ key: 'actions' })
    this.extraParams = { letter: this.$route.params.id }
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    isTargeted() {
      return (this.letter.letter_type === this.$store.state.staticModule.letterTypeTargeted)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    refetchDataMethod() {
      this.$emit('refetchData')
      this.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'quote'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      ...permission(),
      ...config(),
    }
  },
}
</script>
